import React, { useState, useEffect } from 'react'
import { Card, Modal, ModalBody, ModalHeader, Button } from "reactstrap";
import bg2 from "../../../../assets/utils/images/dropdown-header/city2.jpg";
import styles from '../../../../assets/css/rstyling.module.css'
import Tabs, { TabPane } from "rc-tabs";
import TabContent from "rc-tabs/lib/TabContent";
import ScrollableInkTabBar from "rc-tabs/lib/ScrollableInkTabBar";
import Search from '../../../../assets/images/search_icon.png'
import { TransitionGroup } from 'react-transition-group';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ResizeDetector from "react-resize-detector";
import Participant from './Participants';
import PageHeader from '../../../../assets/components/pageheader/PageHeader';
import Projecticon from '../../../../assets/images/project_header_icon.png'
import ArrowLeft from "../../../../assets/images/arrow_left.png";
import Excerpts from './Excerpts';

// ******* This component is called in the view icon of general forum listing**********

const GeneralForumActivity = (props) => {

    const history = useNavigate()
    const params = useParams()
    let { search } = useLocation();
    const query = new URLSearchParams(search);
    const [searchedParticipant, set_searchedParticipant] = useState('')
    

    // Card Header
    const getHeader = () => {
        return <div className="form-inline my-2 my-sm-0">
            <div className="input-group input-group-sm" style={{ width: '40vw', maxWidth: '300px' }}>
                <div className="input-group-prepend border-0">
                    <span className={`bg-white my-sm-0 input-group-text form-control-sm ${styles.search_input}`}> <img src={Search} alt="search" /></span>
                </div>
               
                <input className={`form-control input-sm mr-sm-2 p-0 m-0 border-left-0 form-control-sm ${styles.search_input}`} type="search" placeholder="Search by email or phone" aria-label="Search"  onChange={(e) => set_searchedParticipant(e.target.value)} />
            </div>
        </div>
    }

    return (

        <TransitionGroup component="div"transitionName="TabsAnimation" transitionAppear={true}
            transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>

            <div className='project_header'>
                <PageHeader
                    heading="General Forums" img={Projecticon}
                />
            </div>

            {/* Back Icon */}
            <span onClick={() => history(-1)} style={{ cursor: 'pointer' }}>
                <img src={ArrowLeft} alt="" width="8px" />
                <label className="ml-2" style={{ cursor: 'pointer' }}>Back</label>
            </span>

            <ResizeDetector
                handleWidth
                render={({ width }) => (
                    <div className="card_radius">
                        <Card className="mb-0 mt-3">
                            <div className="dropdown-menu-header">
                                <div className="dropdown-menu-header-inner bg-dark">
                                    <div className="menu-header-image"
                                        style={{
                                            backgroundImage: "url(" + bg2 + ")",
                                        }}>
                                    </div>
                                    {/* table header */}
                                    <div className="menu-header-content" style={{ display: 'flex' }}>
                                        <div className="menu-header-content-left mr-auto">
                                            <div className="menu-header-title text-white text-left" style={{ fontWeight: '500' }}>General Forums</div>
                                        </div>

                                        <div className="menu-header-content-right">
                                            {/* Card Header */}
                                            {getHeader()}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={width >= 708 ? "tab_blue tab_center" : "tab_blue"}>

                                <Tabs defaultActiveKey={query.get("tab")} onChange={(key) => key === '3' && history('/admin/preview-generalforum/' + params.activityid)}
                                    renderTabBar={() => <ScrollableInkTabBar color="primary" />}
                                    renderTabContent={() => <TabContent />}  animated={false}  >

                                    <TabPane tab="Participant" key="1">
                                        <Participant searchedParticipant={searchedParticipant}/>
                                    </TabPane>

                                    {/* <TabPane tab="Excerpts" key="2" >
                                        <Excerpts />
                                    </TabPane> */}

                                    <TabPane tab="View Form" key="3">
                                    </TabPane>

                                 </Tabs> 

                            </div>


                        </Card>

                    </div>
                )}

            />
        </TransitionGroup>


    )
}

export default GeneralForumActivity
